import AsyncControl from '@/Controls/AsyncControl';
import ComponentManager from '@/Management/ComponentManager';
import FlowLayoutViewModelType from '@/ViewModels/Controls/FlowLayoutViewModel';

export default class FlowLayout extends AsyncControl {

    private jQueryControl: JQuery;

    public constructor(private viewModel: FlowLayoutViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div class="c-flowlayout-wrapper"><div></div></div>');

        this.applyBindings(this.jQueryControl.find('div'), {
            controlName: 'flowlayout',

            controlIdent: this.identifier,

            loader: this.viewModel.isBusy,

            flowLayout: {
                parent: this,

                mode: this.viewModel.mode,

                orientation: this.viewModel.orientation,

                columnLayout: this.viewModel.columnLayout,

                items: this.viewModel.flowLayoutItems
            },

            classes: this.definePureComputed({
                read: function () {
                    return ['c-alignment-' + this.viewModel.alignment.toLowerCase()];
                }
            })
        });

        $('<div class="clear">').appendTo(this.jQueryControl);

        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('FlowLayout', FlowLayout, 'RADPresentation.HTMLClient.DefaultViewExtensions');